import { call, put, takeLatest } from 'redux-saga/effects';
import { PatientsAPI } from '../../../api/patientsAPI';
import { ToastType } from '../../../utils/interfaces';
import {
  REACTIVATE_PATIENT_ERROR,
  REACTIVATE_PATIENT_REQUEST,
  REACTIVATE_PATIENT_SUCCESS,
  SET_TOAST,
} from '../../actions';

function* workerReactivatePatient(action: {
  type: string;
  payload: { patientPublicId: string; navigate: Function };
}): Generator<any> {
  try {
    const { patientPublicId, navigate } = action.payload;
    const response: any = yield call(PatientsAPI.reactivatePatient, patientPublicId);

    if (!response?.id) {
      throw new Error('Reactivation response did not include a patient id');
    }

    yield put({
      type: REACTIVATE_PATIENT_SUCCESS,
      payload: { reactivatedPatient: response },
    });
    navigate(`/patients/create?id=${encodeURIComponent(response.id)}`, { replace: true });
  } catch (error: any) {
    yield put({
      type: REACTIVATE_PATIENT_ERROR,
      payload: { code: error?.response?.status, message: error?.message },
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Couldn't reactivate patient",
        type: ToastType.ERROR,
      },
    });
  }
}

export function* watcherReactivatePatient() {
  yield takeLatest(REACTIVATE_PATIENT_REQUEST, workerReactivatePatient);
}
